import { Component, Vue, Watch } from "vue-property-decorator";
import Axios from "../../../plugins/http";

@Component
export default class customeService extends Vue {
  [x: string]: any;
  selectArea: any = [];
  options: any = [];
  cpList: any = [];
  search: any = {
    province: "",
    city: "",
    district: "",
    search: "",
    fileId: "",
  };

  tableData: any = [];
  pageNo: number = 1;
  pageSize: number = 20;
  total: number = 0;

  isShow: boolean = false;
  form: any = {
    id: "",
    cpCode: "",
  };
  selectOldText: string = "";

  created() {
    this.getCpList();
    this.getCityList();
    if (this.$route.query.id) {
      this.search.fileId = this.$route.query.id;
      this.getList();
    }
  }
  onSearch() {
    this.pageNo = 1;
    this.getList();
  }
  onRest() {
    this.selectArea = [];
    this.pageNo = 1;
    this.search.search = "";
    this.getList();
  }
  getCpList() {
    Axios.getSecret("/api/common/logistics/all").then((res: any) => {
      if (res.data.status == 200) {
        this.cpList = res.data.data || [];
      }
    });
  }
  getCityList() {
    Axios.getSecret("/api/common/cascadingAreas").then((res: any) => {
      if (res.data.status === 200) {
        res.data.data.map((item: any) => {
          if (item.children && item.children.length > 0) {
            item.children.map((i: any) => {
              if (i.children && i.children.length > 0) {
                i.children.map((a: any) => {
                  if (a.children && a.children.length > 0) {
                  } else {
                    a.children = null;
                  }
                });
              } else {
                i.children = null;
              }
            });
          } else {
            item.children = null;
          }
        });
        this.options = res.data.data;
      }
    });
  }
  getList() {
    let [province = "", city = "", district = ""] = this.selectArea;
    let data = {
      condition: {
        province,
        city,
        district,
        search: this.search.search,
        fileId: this.search.fileId,
      },
      pageNo: this.pageNo,
      size: this.pageSize,
    };
    Axios.postByJson("/api/order/import/detail/page", data).then((res: any) => {
      if (res.data.status == 200) {
        res.data.data.records.map((item: any) => {
          item.selectArea = [
            item.editableProvince || "",
            item.editableCity || "",
            item.editableDistrict || "",
          ];
          item.isEdit = false;
        });
        this.tableData = res.data.data.records || [];
        console.log(this.tableData);
        this.pageNo = Number(res.data.data.current);
        this.total = Number(res.data.data.total);
      } else {
        this.tableData = [];
        this.pageNo = 1;
        this.total = 0;
        this.$message.error(res.data.msg);
      }
    });
  }
  changePage(pageNo: number) {
    this.pageNo = pageNo;
    this.getList();
  }
  onPush(props: any) {
    if (props.isEdit) {
      this.$message.error("请保存后再推送");
      return;
    }
    this.form.id = props.id;
    this.isShow = true;
  }
  handleClose() {
    this.form.id = "";
    this.form.cpCode = "";
    this.isShow = false;
  }
  onSubmit() {
    if (this.form.cpCode === "") {
      this.$message.error("请选择快递公司");
      return;
    }
    let data = {
      id: this.form.id,
      cpCode: this.form.cpCode,
    };
    Axios.postByJson("/api/order/import/detail/push", data).then((res: any) => {
      this.getList();
      this.handleClose();
      if (res.data.status == 200) {
        this.$message({
          type: "success",
          message: "推送成功!",
        });
      } else {
        this.$message.error(res.data.msg);
      }
    });
  }
  onJump() {
    window.open("http://172.16.0.3:6050/#/");
  }
  onBack() {
    window.history.go(-1);
  }
  onEditRow(row: any) {
    row.isEdit = true;
  }
  onSaveRow(row: any) {
    let data = {
      editableProvince: row.selectArea[0] || "",
      editableCity: row.selectArea[1] || "",
      editableDistrict: row.selectArea[2] || "",
      id: row.id,
      fullAddress: row.fullAddress,
      receiverName: row.receiverName,
      receiverPhone: row.receiverPhone,
      skuName: row.skuName,
      skuCodes: row.skuCodes,
    };
    Axios.postByJson("/api/order/import/detail/save", data).then((res: any) => {
      if (res.data.status == 200) {
        this.$message({
          type: "success",
          message: "更新成功",
        });
        row.isEdit = false;
      } else {
        this.$message.error(res.data.msg);
      }
    });
  }
}
